import FORMFIELD from '../../../../../../../DOM/form/fieldset/formfieldgroup/formfield/FORMFIELD.js';
import { makeStruct } from '../../../../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../../../../enums/ModelData.js';
import { labelModel } from '../../../../../../../DOM/form/label/LABEL.js';
import { fieldModel } from '../../../../../../../DOM/form/fieldset/field/FIELD.js';
import { spanModel } from '../../../../../../../DOM/span/SPAN.js';
import INPUTDATE from '../../../../../../../DOM/form/fieldset/field/input/inputs/INPUTDATE.js';
import { buttongroupModel, buttongroupAttr } from '../../../../../../../DOM/GROUP/buttongroup/BUTTONGROUP.js';
// Model Structure
export const formInputDateAttr = makeAttrStruct([
    ['class']
]);
export const formInputDateData = makeDataStruct([
    ['label', labelModel()],
    ['field', fieldModel()],
    ['message', spanModel()],
    ['buttons', buttongroupModel(buttongroupAttr('form-field-buttons'))]
]);
export const formInputDateModel = makeStruct([
    ['attributes', formInputDateAttr],
    ['data', formInputDateData]
]);
// Simplified Model
export function formInputDate(label, field, message, className) {
    return {
        attributes: formInputDateAttr(className),
        data: formInputDateData(label, field, message)
    };
}
/** Represents an Input[type=date] for a Form */
export default class FORMINPUTDATE extends FORMFIELD {
    constructor(node, model) {
        super(node, model);
    }
    createField(model) {
        return new INPUTDATE(this, model);
    }
}
